import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class UserAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenUserAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getUserTableList', {
            url: '/admin/user/userSheet',
            name: 'list',
            label: '列表'
        }],

        ['addNewUser', {
            url: '/admin/user/createUser',
            name: 'add-new-user',
            label: '添加用户'
        }],
        // ['getUserDetail', {
        //     url: '/admin/user/show',
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 用户列表
    public getUserTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getUserTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 添加用户
    public addNewUser(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addNewUser').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
    


}